import React, { useMemo } from 'react';
import PaginationComponent from 'react-reactstrap-pagination';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { displayPaginationMessage } from '../../Helpers/jobHelper';

const TABLE_SIZE = [
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 75, label: '75' },
];

const Pagination = ({ pageSize, totalItems, activePage, onTableSizeSelect, onPaginationSelect, pagination }) => {
  const { t } = useTranslation();
  const numElements = useMemo(() => {
    const value = TABLE_SIZE.find((x) => x.value.toString() === pageSize.toString());
    return value;
  }, [pageSize]);

  return (
    <div className="d-flex justify-content-between">
      <Select
        name="tags"
        value={numElements}
        onChange={(item) => onTableSizeSelect(item, 'tags')}
        options={TABLE_SIZE}
      />
      <div>
        <PaginationComponent
          totalItems={totalItems}
          pageSize={Number(pageSize)}
          onSelect={(item) => onPaginationSelect(item)}
          maxPaginationNumbers={5}
          defaultActivePage={activePage}
          firstPageText="<<"
          previousPageText="<"
          nextPageText=">"
          lastPageText=">>"
        />
        <b>{displayPaginationMessage(pagination, t)}</b>
      </div>
    </div>
  );
};

export default Pagination;
